import React from 'react'
import { connect } from 'react-redux'
import PaymentDetail from './Components/PaymentDetail/PaymentDetail'
import {
  getGroupPaymentRequest,
  updateGroupPaymentStatusRequest,
  updateGroupPaymentStatusReset,
  resolveOmkPaymentLabelsRequest
} from './Redux/actions'
import { labelsNeededFor } from './lib/labels'

class PaymentDetailPage extends React.Component {
  constructor(props) {
    super(props)
    this.updateStatus = this.updateStatus.bind(this)
    this.resetUpdateStatus = this.resetUpdateStatus.bind(this)
  }

  componentWillMount() {
    const params = this.props.params || {}
    if (params.groupGuid && params.paymentGuid) {
      this.props.dispatch(
        getGroupPaymentRequest({
          group_guid: params.groupGuid,
          payment_guid: params.paymentGuid
        })
      )
    }
  }

  componentDidUpdate(prevProps) {
    const previous = prevProps.omkGroupPaymentData.current_payment
    const current = this.props.omkGroupPaymentData.current_payment
    if (current && current !== previous) {
      // The payment names its group and its maker/checker by guid only.
      this.props.dispatch(
        resolveOmkPaymentLabelsRequest(labelsNeededFor([current]))
      )
    }
  }

  updateStatus(payload) {
    this.props.dispatch(updateGroupPaymentStatusRequest(payload))
  }

  resetUpdateStatus() {
    this.props.dispatch(updateGroupPaymentStatusReset())
  }

  render() {
    const data = this.props.omkGroupPaymentData
    const params = this.props.params || {}
    return (
      <PaymentDetail
        payment={data.current_payment}
        loader={data.current_payment_loader}
        error={data.current_payment_error}
        groupGuid={params.groupGuid}
        paymentGuid={params.paymentGuid}
        groupLabels={data.group_labels}
        userLabels={data.user_labels}
        update_status_loader={data.update_status_loader}
        update_status_success={data.update_status_success}
        update_status_error={data.update_status_error}
        updateStatus={this.updateStatus}
        resetUpdateStatus={this.resetUpdateStatus}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    omkGroupPaymentData: state.omkGroupPaymentData
  }
}

export default connect(mapStateToProps)(PaymentDetailPage)
